/**
 * Search Autocomplete State Layer
 * Holds autocomplete query/results state and mediates between the UI and API
 * layers via the shared searchAutocomplete event bus.
 */

class SearchAutoCompleteStateLayer {
  constructor () {
    this.eventBus = window.theme.tagalys.searchAutocomplete.eventBus

    this.state = {
      keywords: [],
      products: [],
      popular: [],
      collections: [],
      term: ''
    }

    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('searchAutoComplete:ui:term:updated', (response) => {
      const { term } = response

      this.term = term
    })

    this.eventBus.subscribe('searchAutoComplete:api:results:fetched', (response) => {
      this.products = response?.sections?.products?.items ?? []
      this.keywords = response?.sections?.searches?.items ?? response?.sections?.queries?.items ?? []

      this.eventBus.publish('searchAutoComplete:state:updated', this.state)
    })

    this.eventBus.subscribe('searchAutoComplete:api:initial:fetched', (response) => {
      this.popular = response

      this.eventBus.publish('searchAutoComplete:state:initial:updated', this.state.popular)
    })
  }

  set term (term) {
    this.state.term = term

    this.eventBus.publish('searchAutoComplete:state:term:updated', term)
  }

  set keywords (keywords) {
    this.state.keywords = keywords
  }

  set products (products) {
    this.state.products = products
  }

  set popular (popular) {
    this.state.popular = popular
  }

  get term () {
    return this.state.term
  }

  get keywords () {
    return this.state.keywords
  }

  get products () {
    return this.state.products
  }

  get popular () {
    return this.state.popular
  }
}

window.theme.tagalys.searchAutocomplete.stateLayer = new SearchAutoCompleteStateLayer()
